import React from "react";
import { Outlet } from "react-router-dom";

// import Login from "../views/Auth/Login.js";

const Auth = () => {
    return (
        <>
            <Outlet />
        </>
        //Footer
    );
};

export default Auth;
